import type { SiteState } from "./site-state";
import { Show } from "zyra";
import { getPage } from "../content";
import { Header } from "../components/Header";
import { Sidebar } from "../components/Sidebar";
import { DocumentPage } from "../components/DocumentPage";
import { DocLink } from "../components/DocLink";

export function DocsLayout(props: { site: SiteState }) {
  const site = props.site;
  const { menu, current } = site;
  return (
    <>
      <a class="skip-link" href="#content">
        Skip to content
      </a>
      <Header site={site} />
      <div class="site-grid">
        <Show when={menu.value}>
          <button
            class="sidebar-backdrop"
            aria-label="Close navigation"
            onClick={() => {
              menu.value = false;
            }}
          />
        </Show>
        <Sidebar site={site} />
        <main id="content" class="main" tabIndex={-1}>
          {() => {
            const page = current.value;
            return page ? (
              <DocumentPage site={site} page={page} />
            ) : (
              <article class="document not-found">
                <div class="eyebrow">404 / LOST IN THE DOCS</div>
                <h1>
                  Nothing here. <span>Yet.</span>
                </h1>
                <p class="description">
                  This documentation page doesn't exist.
                </p>
                <DocLink site={site} page={getPage("")} class="primary-button">
                  Back to documentation ↗
                </DocLink>
              </article>
            );
          }}
        </main>
      </div>
    </>
  );
}
